export default __webpack_public_path__ + "static/media/img2.6b0d6853.jpg";